import { render, staticRenderFns } from "./emailPreferenceForm.vue?vue&type=template&id=410af0a6&scoped=true&"
import script from "./emailPreferenceForm.vue?vue&type=script&lang=ts&"
export * from "./emailPreferenceForm.vue?vue&type=script&lang=ts&"
import style0 from "./emailPreferenceForm.vue?vue&type=style&index=0&id=410af0a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410af0a6",
  null
  
)

export default component.exports